import {wordIdToWord} from "$lib/data/wordIdToWord";
import type {WordId} from "$lib/classes/data/_primitives";
import {Noun} from "$lib/classes/data/word";

// TODO wordIdToWord as parameter or Word
export function getGenderClass(id: WordId) {

    const word = wordIdToWord[id]

    if (word instanceof Noun) {
        const pluralIds = [
            'noun/die-Großeltern',
            'noun/die-Pommes frites',
            'noun/die-Leute',
            'noun/die-Eltern',
            'noun/die-Papiere',
            'noun/die-Kosten',
            'noun/die-Medien',
            'noun/die-Daten',
            'noun/die-Ferien',
            'noun/die-Fachleute',
            'noun/die-Schwiegereltern',

            'noun/die-Schulden',
            'noun/die-Unterlagen',
        ]
        if (pluralIds.includes(id)) {
            return ''
        } else {
            return word.genus.toString().toLowerCase()
        }
    } else {
        return ''
    }
}
